module.exports = __webpack_public_path__ + "img/year-bill-index-btn.d903b484.png";